import { makeStyles } from '@material-ui/core/styles';

import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  imageListContainer: {
    marginTop: '210px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: '130px',
    },
  },
  imageIcon: {
    width: '74px',
    height: '106px',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      width: '12%',
      height: 'auto',
      marginLeft: '2px',
      marginRight: '2px',
    },
  },
}));

const RetentionImageList = (props) => {
  const { images } = props;
  const classes = useStyles();

  const openLink = (targetUrl) => {
    window.open(targetUrl, '_blank');
  };

  return (
    <Box className={classes.imageListContainer}>
      <span>
        {images.map((image, index) => (
          <img
            alt={image.targetUrl}
            src={image.image}
            key={index}
            className={classes.imageIcon}
            onClick={() => openLink(image.targetUrl)}
          />
        ))}
      </span>
    </Box>
  );
};

export default RetentionImageList;
